export default [
    {
        name: "Home",
        path: "Home",
        component: () => import("@/view/WebView/Home"),
        meta: {
            title: "",
            footer: true,
        }
    },
    {
        name: "Nation",
        path: "Nation",
        component: () => import("@/view/WebView/Nation"),
        meta: {
            title: "",
            footer: true,
        }
    },
    
]